import React from 'react';
import { InstagramIcon, FacebookIcon, HeartIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white py-12" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-45">
          {/* Brand */}
          <div data-id="element-46">
            <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-47">Gardendale</h3>
            <p className="text-sm text-gray-400 italic tracking-widest mb-4" data-id="element-48">
              VENUE
            </p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-49">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-50">
            <h4 className="text-sm font-bold tracking-widest mb-4" data-id="element-51">
              QUICK LINKS
            </h4>
            <nav className="flex flex-col gap-2" data-id="element-52">
              <a href="#home" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-53">
                Home
              </a>
              <a href="#about" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-54">
                About
              </a>
              <a href="#venue" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-55">
                Venue
              </a>
              <a href="#gallery" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-56">
                Gallery
              </a>
              <a href="#contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-57">
                Contact
              </a>
            </nav>
          </div>

          {/* Contact & Social */}
          <div data-id="element-58">
            <h4 className="text-sm font-bold tracking-widest mb-4" data-id="element-59">
              CONNECT WITH US
            </h4>
            <div className="space-y-2 mb-4" data-id="element-60">
              <p className="text-gray-400 text-sm" data-id="element-61">(555) 123-4567</p>
              <p className="text-gray-400 text-sm" data-id="element-62">hello@gardendalevenue.com</p>
            </div>
            <div className="flex gap-4" data-id="element-63">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-64">
                <InstagramIcon className="w-5 h-5" data-id="element-65" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-66">
                <FacebookIcon className="w-5 h-5" data-id="element-67" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-68">
          <p className="text-gray-400 text-sm" data-id="element-69">
            © 2024 Gardendale Venue. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-2" data-id="element-70">
            Made with <HeartIcon className="w-4 h-4 fill-current" data-id="element-71" /> for
            unforgettable celebrations
          </p>
        </div>
      </div>
    </footer>;
}